import { useEffectiveConfiguration } from './useSocietyConfiguration';

/**
 * Indique si la société peut encaisser un contrat en paiement mensualisé
 *
 * Règles (configuration effective, merge groupe + propre) :
 * - mensualisation active (monthlyPayment === 2)
 * - compte Stripe renseigné
 * Tant que la configuration n'est pas chargée : false
 */
export const useCanMonthlyPayment = (societyId: string | undefined): boolean => {
  const { data: config } = useEffectiveConfiguration(societyId);
  return config?.monthlyPayment === 2 && !!config?.stripeAccountId;
};
